import { useCallback, useState } from 'react'
import cx from 'classnames'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import PropTypes from 'prop-types'

import PlayButtonOverlay from 'common/components/PlayButtonOverlay'
import bynderDATLoader from 'common/utils/bynderDATLoader'
import { DAT_TRANSFORM_URL } from 'common/utils/getBynderDATSrc'
import { Loading } from 'common/widgets'
import classNames from './styles.module.scss'


VideoContainer.propTypes = {
  video: PropTypes.string,
  videoImage: PropTypes.string,
  type: PropTypes.string,
  aspectRatio: PropTypes.oneOf(['v', 'h']).isRequired,
  withHeading: PropTypes.bool,
}

const Video = dynamic(() => import('./Video'), { ssr: false,
  loading: () => <Loading isLoading fontSize={48} /> })

export default function VideoContainer({
  video: src = undefined,
  videoImage = undefined,
  type = 'video/mp4',
  aspectRatio,
  withHeading = false,
}) {
  const [isPlayerEnabled, setIsPlayerEnabled] = useState(!videoImage)
  const [player, setPlayer] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const handleClick = useCallback(() => {
    setIsPlayerEnabled(isPlayerEnabled => {
      if(!isPlayerEnabled) {
        return true
      }
      if(player) {
        if(player.paused() && isPlaying === false) {
          player.play()
        }
      }
      return isPlayerEnabled
    })
  }, [isPlaying, setIsPlayerEnabled, player])

  return (
    <div
      className={cx(classNames.videoContainer, aspectRatio === 'v' ? classNames.vertical : classNames.horizontal, withHeading && classNames.withHeading)}
    >
      {isPlayerEnabled
        ? (
          <Video src={videoImage ? src : src + '#t=0.1'} type={type} videoImage={videoImage} setIsPlaying={setIsPlaying} setPlayer={setPlayer} />)
        : (
          <Image
            src={videoImage}
            loader={
              videoImage?.includes(`${DAT_TRANSFORM_URL}/`)
                ? ({ src, width, quality }) =>
                  bynderDATLoader({
                    src: src.replace(/\?.*$/, ''),
                    width,
                    quality,
                    aspectRatio: aspectRatio === 'v' ? 406 / 720 : 16 / 9,
                    maxHeight: aspectRatio === 'v' ? 1000 : undefined,
                  })
                : undefined
            }
            sizes="(max-width: 767px) 100vw,
                     33vw"
            fill
            style={{
              objectFit: 'cover',
            }}
            alt="video poster"
          />
        )}
      {!isPlaying && (
        <PlayButtonOverlay
          className={classNames.playButtonOverlay}
          onClick={handleClick}
        />
      )}
    </div>
  )
}
